import React from 'react';
import { useTranslation } from 'react-i18next';

export const BrandVoice = () => {
  const { t, i18n } = useTranslation();
  const isEnglish = i18n.language === 'en';
  
  const voiceItems = [
    { tr: 'Hareket ettikçe güçlenirsin.', en: 'You grow stronger with every move.' },
    { tr: 'Bugün kendin için bir adım at.', en: 'Take a step for yourself today.' },
    { tr: 'Flow\'a güven. Pilatika yanında.', en: 'Trust the flow. Pilatika is with you.' },
    { tr: 'Bedeni güçlendir, zihni sakinleştir.', en: 'Strengthen the body, calm the mind.' }
  ];

  return (
    <section className="py-16 movea-soft-gradient">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {voiceItems.map((item, index) => (
            <div 
              key={index} 
              className="glass-effect p-6 rounded-2xl text-center fade-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <p className="text-lg font-semibold text-gradient mb-2">
                {isEnglish ? item.en : item.tr}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};